import { endOfDay, endOfISOWeek, startOfDay, startOfISOWeek, subWeeks } from "date-fns";

export function toYmd(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export type IsoWeekRange = {
  from: string;
  to: string;
  fromDate: Date;
  toDate: Date;
};

/**
 * Current: ISO week Monday 00:00 through end of today (week-to-date).
 * Previous: the **full** ISO week immediately before (Monday–Sunday inclusive).
 *
 * This includes all sales from last week in the baseline (e.g. a sale on Friday
 * of last week is counted), which “aligned same weekdays” did not do on Monday
 * or when the sale fell after the aligned end day.
 */
export function getAlignedIsoWeekVsPreviousRanges(now = new Date()): {
  current: IsoWeekRange;
  previous: IsoWeekRange;
} {
  const thisWeekStart = startOfDay(startOfISOWeek(now));
  const todayEnd = endOfDay(now);

  const prevWeekStart = startOfDay(subWeeks(thisWeekStart, 1));
  const prevWeekEnd = endOfDay(endOfISOWeek(prevWeekStart));

  return {
    current: {
      from: toYmd(thisWeekStart),
      to: toYmd(todayEnd),
      fromDate: thisWeekStart,
      toDate: todayEnd,
    },
    previous: {
      from: toYmd(prevWeekStart),
      to: toYmd(prevWeekEnd),
      fromDate: prevWeekStart,
      toDate: prevWeekEnd,
    },
  };
}
